import { CorpList } from "components/front/APP/Corp/List/CorpList"
import React from "react"



export const CorpListRoute = () => {
  return <div>
    <CorpList />
  </div>
}